export default () => {
  const config = useRuntimeConfig();

  const currentPortalPassPriceIds = computed((): string[] => {
    return [
      config.public.stripePricePortalPassTwentyFive,
      config.public.stripePricePortalPassTwentyFiveDiscounted,
      config.public.stripePriceSoftballPortalPassTwentyFive,
      config.public.stripePriceSoftballPortalPassTwentyFiveDiscounted,
    ].filter((id): id is string => typeof id === 'string' && id.length > 0);
  });

  return {
    currentPortalPassPriceIds,
  };
};
